import { render, staticRenderFns } from "./content-layout.vue?vue&type=template&id=4e1b22f7&scoped=true&"
import script from "./content-layout.vue?vue&type=script&lang=ts&"
export * from "./content-layout.vue?vue&type=script&lang=ts&"
import style0 from "./content-layout.vue?vue&type=style&index=0&id=4e1b22f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1b22f7",
  null
  
)

export default component.exports